module.exports = __webpack_public_path__ + "img/MenungguTindakLanjut.f863485d.svg";